export default function ErrorMessage({ children }) {
    return (
        <div className=" absolute text-[#F04438] text-[13px] text-left">
            {children}
        </div>
    )
};
